import { Grid } from "@mui/material";
import MxButtonIdiom from "@rf-l1/buttons/MxButtonIdiom";
import MXDescriptionToggle from "@rf-l1/MXDescriptionToggle";
import MxTypography from "@rf-l1/MxTypography";
import MxDetailSubTitle from "@rf-l1/page/details/MxDetailSubTitle";
import { useState } from "react";

interface IMainDetailDescriptionProps {
  descriptions: {
    es?: string;
    en?: string;
  };
}
const MainDetailDescription = (props: IMainDetailDescriptionProps) => {
  const [idiom, setIdiom] = useState<"es" | "en">("es");
  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container alignItems="center" gap={1}>
          <Grid item xs={"auto"}>
            <MxDetailSubTitle label="Descripción" />
          </Grid>
          <Grid item xs={"auto"}>
            <MxButtonIdiom
              idiom={idiom}
              onClick={idiom => setIdiom(idiom)}
              availableIdioms={{
                es: Boolean(props.descriptions.es),
                en: Boolean(props.descriptions.en)
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <MXDescriptionToggle
          collapsedSize={90}
          text={
            idiom === "es"
              ? props.descriptions.es ?? ""
              : props.descriptions.en ?? ""
          }
        />
      </Grid>
    </Grid>
  );
};

export default MainDetailDescription;
